<div class="v3">
    @if (showTitle) {
    <span mat-dialog-title>
        <p class="padding-x-24 padding-top-24 padding-bottom-16"
            [ngClass]="{'typography-title-large d-flex justify-content-center w-100': isMobile, 'typography-headline-small': !isMobile}">
            <ng-content select="[title]"></ng-content>
        </p>
    </span>
    }

    <mat-dialog-content>
        <div class="padding-bottom-24">
            <ng-content select="[content]"></ng-content>
        </div>
    </mat-dialog-content>

    @if (showActions) {
        <mat-dialog-actions>
            <ng-content select="[submissionBar]"></ng-content>
        </mat-dialog-actions>
    }
</div>